/* global axios */
import ApiClient from './ApiClient';

const getAccountIdFromURL = () => {
  const isInsideAccountScopedURLs =
    window.location.pathname.includes('/app/accounts');
  if (isInsideAccountScopedURLs) {
    return window.location.pathname.split('/')[3];
  }
  return '';
};

class UazapiAPI extends ApiClient {
  constructor() {
    super('accounts/uazapi', { accountScoped: true });
  }

  instanceInfo({ inbox_id, accountId }) {
    const finalAccountId =
      accountId || getAccountIdFromURL() || this.accountIdFromRoute;

    return axios.get(
      `/api/v1/accounts/${finalAccountId}/uazapi/instance_info`,
      {
        params: {
          inbox_id,
        },
      }
    );
  }

  numberHealth({ inbox_id, accountId }) {
    const finalAccountId =
      accountId || getAccountIdFromURL() || this.accountIdFromRoute;

    return axios.get(
      `/api/v1/accounts/${finalAccountId}/uazapi/number_health`,
      {
        params: {
          inbox_id,
        },
      }
    );
  }

  verifyNumbers({ inbox_id, accountId, numbers }) {
    const finalAccountId =
      accountId || getAccountIdFromURL() || this.accountIdFromRoute;

    return axios.post(
      `/api/v1/accounts/${finalAccountId}/uazapi/verify_numbers`,
      {
        inbox_id,
        numbers,
      }
    );
  }

  disconnectInstance({ inbox_id, accountId }) {
    const finalAccountId =
      accountId || getAccountIdFromURL() || this.accountIdFromRoute;

    return axios.post(
      `/api/v1/accounts/${finalAccountId}/uazapi/disconnect_instance`,
      {
        inbox_id,
      }
    );
  }

  generateQRCode({ inbox_id, accountId, phone_number }) {
    const finalAccountId =
      accountId || getAccountIdFromURL() || this.accountIdFromRoute;

    return axios.post(
      `/api/v1/accounts/${finalAccountId}/uazapi/generate_qr_code`,
      {
        inbox_id,
        phone_number,
      }
    );
  }
}

export default new UazapiAPI();
